// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 347) return "static/chunks/347.08aaec69eed2a60f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"318":"7a195008d5390ea2","541":"c1cbefabf08fdf82","3792":"0e3045ccbbaf6d68","4481":"3af27230299fdd46","4609":"070af1a25a6b4774","5675":"ff565fb9f6c90f45","8441":"ca7e5ec81857f4bd","9162":"279bad262bfcc6ba"}[chunkId] + ".js";
};